<section id="ngx-datatable-filter">
    <div class="row">
      <div class="col-12"></div>
      <div class="col-12">
        <div class="card">
          <div class="card-content">
            <div class="card-body">
              <!-- ngx-datatable-filter -->
              <div class="ngx-datatable-container">
                <div>
                  <ngx-datatable *ngIf="rows?.length > 0" class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force"
                    [headerHeight]="50" [footerHeight]="50" rowHeight="auto" [limit]="limitRef" [rows]="rows"
                    [scrollbarH]="true" [columns]="columns" [externalPaging]="true" [count]="page.totalPages"
                    [offset]="page.pageNumber" (page)="pageChangeData($event)">
  
                    <!-- Define ngx-datatable columns -->
                    <ngx-datatable-column name="Session Name" prop="title" [width]="80">
                      <ng-template let-row="row" ngx-datatable-cell-template>
                        <div class="d-flex align-items-center cursor-pointer">
                          {{ row?.title }}
                        </div>
                      </ng-template>
                    </ngx-datatable-column>
  
                    <ngx-datatable-column name="Course" prop="course_id" [width]="80">
                      <ng-template let-row="row" ngx-datatable-cell-template>
                        <div class="d-flex align-items-center">
                          {{ row?.course_id[0]?.title }}
                        </div>
                      </ng-template>
                    </ngx-datatable-column>
  
                    <ngx-datatable-column name="Actions" [width]="80">
                      <ng-template let-row="row" ngx-datatable-cell-template>
                        <i mat-button [matMenuTriggerFor]="menu1"
                          class="ft-more-vertical text-primary cursor-pointer mr-2"></i>
                        <mat-menu #menu1="matMenu">
                          <button mat-menu-item (click)="viewTopics(row)">View Topics</button>
                        </mat-menu>
                      </ng-template>
                    </ngx-datatable-column>
  
                  </ngx-datatable>
                </div>
  
                <div *ngIf="rows.length === 0" class="align-items-center text-center d-flex justify-content-center m-5">
                  No data found
                </div>
              </div>
  
              <!-- ngx-datatable-filter -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  
  <div class="d-flex justify-content-between align-items-center">
    <ngx-spinner></ngx-spinner>
  </div>
  